/* UX 15SEP2026 — Restaura los productos cargados por infinite scroll y la posición
   al volver atrás desde una ficha de producto (misma idea que Prestige/Macabla).
   Sin dependencias. Solo actúa en navegaciones "back/forward". */
(function () {
  const KEY = 'hmp:coll:' + location.pathname + location.search;
  const MAX = 3.5 * 1024 * 1024;

  function grid() { return document.querySelector('.load-more-grid'); }
  function data() { return document.querySelector('.infinite-scroll__data') || document.querySelector('.load-more-button')?.parentElement; }
  function val(sel) { const el = document.querySelector(sel); return el ? el.value : null; }

  function save() {
    const g = grid();
    if (!g) return;
    const current = parseInt(val('[data-current-page]') || '1', 10);
    if (current <= 1) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }
    const html = g.innerHTML;
    if (html.length > MAX) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        html: html,
        y: window.scrollY,
        current: current,
        next: val('[data-next-url]'),
        total: val('[data-total-pages]'),
        t: Date.now()
      }));
    } catch (e) { /* cuota llena: ignorar */ }
  }

  function isBackForward() {
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav) return nav.type === 'back_forward';
    return performance.navigation && performance.navigation.type === 2;
  }

  function restore() {
    let cached;
    try { cached = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return; }
    if (!cached) return;
    if (!isBackForward()) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }
    if (Date.now() - cached.t > 30 * 60 * 1000) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }

    const g = grid();
    if (!g) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    g.innerHTML = cached.html;

    const cur = document.querySelector('[data-current-page]');
    const nxt = document.querySelector('[data-next-url]');
    if (cur) { cur.value = cached.current; cur.dataset.currentPage = cached.current; }
    if (nxt && cached.next) { nxt.value = cached.next; nxt.dataset.nextUrl = cached.next; }
    if (cached.total && parseInt(cached.current, 10) >= parseInt(cached.total, 10)) {
      document.querySelectorAll('.js-infinite-scroll, .js-load-more').forEach((el) => el.remove());
    }

    if (typeof colorSwatches === 'function') { try { colorSwatches(); } catch (e) {} }
    if (typeof loadeMoreSlider_G === 'function') { try { loadeMoreSlider_G(); } catch (e) {} }

    const y = cached.y || 0;
    const go = () => window.scrollTo({ top: y, behavior: 'instant' in document.documentElement.style ? 'instant' : 'auto' });
    requestAnimationFrame(go);
    setTimeout(go, 150);
    setTimeout(go, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
  window.addEventListener('pagehide', save);
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('.load-more-grid a')) save();
  }, true);
})();
